

export default class ProcedureDetails {

	constructor(details,listPdfFilePaths, offer, subscriptionCode, userAccount) {
		details = details || {};
		const {title ={}, firstName, lastName} = userAccount.name || "";
		const {email, phone, mobile} = userAccount.contactInformation || userAccount || "";
		const fullName = `${title.code} ${firstName} ${lastName}`;
		const procedureName = `${offer} - ${fullName}`;
		const procedureDescription = procedureName + " Contract";
		const nameFile = `${subscriptionCode}_AutorisationIBAN.pdf`;
		this.withInternalMember = false;
		this.filesToSign = [
			{
				name: nameFile || "Subscription Contract",
				"content": "" ,
				"filePath": listPdfFilePaths[0],
				"listExternalPositions":[ 
						{
						"position" : SIGNATURE_POSITION,
						"page" : 1
						} 
					]
					
			}
		];

		this.procedure = {
			name: procedureName,
			description: procedureDescription,
			start: true,
			members: [
				{
					firstname: firstName,
					lastname: lastName,
					email: email,
					phone: mobile || phone
				}
			]
		};
	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/ProcedureDetails.js